import styled from "@emotion/styled";
import { Box, Typography } from "@mui/material";

export const SkillsContainer = styled(Box)(() => ({
    display: "flex",
    justifyContent: "space-evenly",
    flexWrap: "wrap",
    gap: "19px",
    backgroundColor:"#D7C21B",
}));

export const EachSkill = styled(Box)(() => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    border: "4px solid #007d71",
    boxShadow: "1px 8px 53px 0 rgba(0,0,0,0.2)",
    borderRadius: "14px",
    backgroundColor:"white",
    '&:active':{
        outline: "auto"
    }
}));
export const SkillText = styled(Typography)(() => ({
    backgroundColor: "#007d71",
    width: "100%",
    textAlign: "center",
    color: "white",
    fontSize: "19px",
    fontWeight: "bold"
}));
export const SkillImage = styled('img')(() => ({
    height: "70px",
    width: "70px",
    margin: "3px 6px"
}));

export const SkillsBox=styled(Box)(()=>({
    backgroundColor:"#D7C21B",
    color:"#8000a4",
    scrollMarginTop:"50px",
}));
export const SkillsText=styled(Typography)(()=>({
    fontWeight: "bold",
    fontSize: "26px",
    textAlign: "center",
    marginBottom: "15px"
}))